/**
 * Backstop: never render internal/system instructions or architecture jargon
 * in mentee-visible mentor chat.
 */

const META_PAREN = /\(\s*(?:(?:please\s+)?(?:use|do not|don't|never|always|note:|system:|internal:)[^)]*|[^)]*(?:tier\s*[12]|working[- ]file context|do not invent documents|system-only|internal instruction)[^)]*)\)/gi;

const META_BRACKET = /\[\s*(?:system|internal|instruction|note|use the mentee)[:\s][^\]]{0,500}\]/gi;

const TIER_LABEL = /\b(?:data\s+)?tier\s*[12]\b/gi;

const WORKING_FILE_CONTEXT = /\bworking[- ]file(?:s)?\s+context\b/gi;

export function sanitizeMentorOutput(text: unknown): string {
  if (typeof text !== 'string' || !text) return '';

  let out = text;
  out = out.replace(META_PAREN, '');
  out = out.replace(META_BRACKET, '');
  out = out.replace(WORKING_FILE_CONTEXT, 'the information you have shared');
  out = out.replace(TIER_LABEL, '');
  out = out.replace(/[ \t]{2,}/g, ' ');
  out = out.replace(/[ \t]+\n/g, '\n');
  out = out.replace(/\n{3,}/g, '\n\n');
  out = out.replace(/\s+([,.;:!?])/g, '$1');
  out = out.replace(/[ \t]+—[ \t]+/g, ' — ');
  return out.trim();
}

export function sanitizeAssistantMessages<T extends { role?: string; content?: string }>(
  messages: T[],
): T[] {
  if (!Array.isArray(messages)) return [];
  return messages.map((message) => {
    if (!message || message.role === 'user') return message;
    return {
      ...message,
      content: sanitizeMentorOutput(message.content),
    };
  });
}
